import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import type { Dayjs } from 'dayjs'
import type { AppTimezoneDto } from '../services/api'

dayjs.extend(utc)

export const DEFAULT_APP_TIMEZONE: AppTimezoneDto = {
  offset: '+0500',
  offsetMinutes: 300,
  label: 'UTC+5',
}

export function getAppTimezoneOffsetMinutes(timezone?: AppTimezoneDto | null) {
  const offsetMinutes = timezone?.offsetMinutes
  return Number.isFinite(offsetMinutes) ? Number(offsetMinutes) : DEFAULT_APP_TIMEZONE.offsetMinutes
}

export function appTimezoneNow(timezone?: AppTimezoneDto | null) {
  return dayjs().utcOffset(getAppTimezoneOffsetMinutes(timezone))
}

export function formatInAppTimezone(value: string, format: string, timezone?: AppTimezoneDto | null) {
  const parsed = dayjs(value)
  if (!parsed.isValid()) return value

  return parsed.utcOffset(getAppTimezoneOffsetMinutes(timezone)).format(format)
}

export function dateTimeToAppTimezone(value: string, timezone?: AppTimezoneDto | null): Dayjs | null {
  const parsed = dayjs(value)
  if (!parsed.isValid()) return null

  return parsed.utcOffset(getAppTimezoneOffsetMinutes(timezone))
}
